module.exports = __webpack_public_path__ + "assets/img/crayon1.c53e27b4.png";